import { useState } from "react";

import LoadingSpinner from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import Modal from "../Modal/Modal";
import { PAYMENT_TABLE_MODAL_STATES } from "../Payment/common/utils";
import { Button, Container } from "./PaymentDeletionModalStyles";

function PaymentDeletionModal(props) {
  const {
    toggleModal,
    quotationNum,
    quotationId,
    setShowModalDeleteSuccess,
    setMessageDeleteSuccess,
    setTitleMessageDeleteSuccess,
    updatetModalState,
  } = props;
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);
  const onClose = () => {
    if (!waitingForServerResponse) {
      toggleModal();
    }
  };

  const onDelete = () => {
    updateWaitingForServerResponse(true);
    makeRequest(quotationId)
      .then((response) => {
        if (!response.ok) {
          setMessageDeleteSuccess(
            `Prefactura del pedido ${quotationNum} no pudo ser eliminada.`
          );
          setTitleMessageDeleteSuccess("Prefactura eliminada correctamente");
        } else {
          setMessageDeleteSuccess(
            `Prefactura del pedido ${quotationNum} eliminada correctamente.`
          );
          setTitleMessageDeleteSuccess("Prefactura eliminada Exitosamente");
        }
      })
      .catch(() => {
        setTitleMessageDeleteSuccess("Atención");
        setMessageDeleteSuccess(
          `Prefactura del pedido ${quotationNum} no pudo ser eliminada.`
        );
      })
      .finally(() => {
        updateWaitingForServerResponse(false);
        updatetModalState(PAYMENT_TABLE_MODAL_STATES.disabled);
        setShowModalDeleteSuccess(true);
      });
  };

  return (
    <Modal onOutsideClick={onClose}>
      <Container>
        <h1>Confirmación de eliminación</h1>
        <div className="description">
          <p>
            ¿Estás seguro de eliminar la prefactura del pedido {quotationNum}?
          </p>
        </div>
        <div className="button-container">
          <Button
            status="confirm"
            onClick={onDelete}
            disabled={waitingForServerResponse}
          >
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            Confirmar eliminación
          </Button>
          <Button status="cancel" onClick={onClose}>
            Cancelar
          </Button>
        </div>
      </Container>
    </Modal>
  );
}

export default PaymentDeletionModal;

function makeRequest(quotationId) {
  return networkBackendRequest(
    `/quotations/${quotationId}/`,
    HTTP_METHODS.DELETE,
    null
  );
}
